// Finland products are Thrillophilia imports only; Scandinavia combos are listed on every Nordic country they visit.
import { finlandEscapadeLaplandInariProduct } from './finlandEscapadeLaplandInariData';
import { scandinaviaGroupTourHelsinkiCopenhagenProduct } from './scandinaviaGroupTourHelsinkiCopenhagenData';
import { scandinaviaClassicFlamRailwayProduct } from './scandinaviaClassicFlamRailwayData';

export const finlandProducts = [
  finlandEscapadeLaplandInariProduct,
  scandinaviaGroupTourHelsinkiCopenhagenProduct,
  scandinaviaClassicFlamRailwayProduct
];
export const finlandTours = [];
export const finlandBySlug = {};
